/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';

import Breadcrumb from 'src/layouts/full/shared/breadcrumb/Breadcrumb';
import PageContainer from 'src/components/container/PageContainer';
import BlankCard from 'src/components/shared/BlankCard';
// import { Teacher } from 'src/types/teacher/teacher';
import axiosServices from 'src/utils/axios';
// import { AxiosResponse } from 'axios';
import { useSnackbar } from 'notistack';
import StripeCheckout from 'react-stripe-checkout';


const BCrumb = [
  {
    to: '/',
    title: 'Home',
  },
  {
    title: 'Request',
  },
];

const Request = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [teacher, setTeacher] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pay, setPay] = useState(false);

  const onToken = async () => {
    setPay(true)
    // const data = new FormData();
    // data.append("source", token.id)
    // // data.append("amount", price)
    // // data.append("course_id", id)
    // // data.append("teacher_id", teacherId)
    // // data.append("course_name", course_Name)
    // const response = await axiosServices.post('https://tehutiapi.netwave-tech.com/api/user/payment/process', data);
    // console.log(response, "stripe")
    // enqueueSnackbar(response.data.message, { variant: 'success' });
    enqueueSnackbar("Payment Sucessfully", { variant: 'success' });
  };


  const columns = [
    {
      accessorKey: 'id', //access nested data with dot notation
      header: 'id',
      size: 150,
    },
    {
      accessorKey: 'course_name',
      header: 'Course Name',
      size: 150,
    },
    {
      accessorKey: 'course_price', //normal accessorKey
      header: 'Course Price',
      size: 200,
    },
    {
      accessorKey: 'user_name', //normal accessorKey
      header: 'User Name',
      size: 200,
    },
    {
      accessorKey: 'status', //normal accessorKey
      header: 'Status',
      Cell: ({ row }) => (
        !pay ?
          row.original.status === "Complete" ?
            <StripeCheckout
              token={onToken}
              stripeKey="pk_test_51IIZO8Kp3j5Y1UYUhdopZryeRKjlRqEcw4rrDhwELKCRDjRSOJtSXicia6jkN63CyflKvQwej7SqGt1MZ6UwKgfz00ipRMArG9"
            >
              <button className='lab-btn w-100'>
                <span>{loading ? <span>...Loading</span> : "Pay"}</span>
              </button>
            </StripeCheckout>
            :
            <p>{row.original.status}</p>
          :
          "Completed"
      ),
      size: 200,
    },
  ]

  const table = useMaterialReactTable({
    columns,
    data: teacher,
    state: { isLoading: loading },
    positionActionsColumn: 'last',
    enableRowActions: false,
  });

  const getStatus = async () => {
    setLoading(true);
    try {
      const response = await axiosServices.get(`/admin/check/status`);
      console.log(response, "admin")
      setTeacher(response.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      enqueueSnackbar(error?.message, { variant: 'error' });
    }
  };

  useEffect(() => {
    getStatus();
  }, [])




  return (
    <PageContainer title="All Request" description="All Request">
      {/* breadcrumb */}
      <Breadcrumb title="Request" items={BCrumb} />
      <BlankCard>
        {/* ------------------------------------------- */}
        {/* Left part */}
        {/* ------------------------------------------- */}

        <MaterialReactTable table={table} />
      </BlankCard>
    </PageContainer>
  );
};

export default Request;
